import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.9984 2.5C8.18124 2.5 4.88827 4.75069 3.37746 8H5.75C6.16421 8 6.5 8.33579 6.5 8.75C6.5 9.16421 6.16421 9.5 5.75 9.5H2C1.44772 9.5 1 9.05228 1 8.5V4.75C1 4.33579 1.33579 4 1.75 4C2.16421 4 2.5 4.33579 2.5 4.75V6.44653C4.40913 3.18909 7.94746 1 11.9984 1C18.0743 1 23 5.92476 23 12C23 18.0752 18.0743 23 11.9984 23C6.01438 23 1.14621 18.2232 1.00023 12.2746C0.990068 11.8606 1.31752 11.5166 1.7316 11.5065C2.14569 11.4963 2.48962 11.8238 2.49978 12.2378C2.62583 17.3743 6.83027 21.5 11.9984 21.5C17.2461 21.5 21.5 17.2466 21.5 12C21.5 6.7534 17.2461 2.5 11.9984 2.5Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.5 7.25C12.5 6.83579 12.1642 6.5 11.75 6.5C11.3358 6.5 11 6.83579 11 7.25V12.75C11 13.0191 11.1442 13.2677 11.3779 13.4012L14.8779 15.4012C15.2375 15.6067 15.6957 15.4817 15.9012 15.1221C16.1067 14.7625 15.9817 14.3043 15.6221 14.0988L12.5 12.3148V7.25Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgHistory;
